import React, {Component} from 'react';
import Formsy from 'formsy-react';
import {TextFieldFormsy} from '@fuse';
import {withStyles, CircularProgress, Button, InputAdornment, Icon} from '@material-ui/core';
import {bindActionCreators} from 'redux';
import * as Actions from 'auth/store/actions';
import {withRouter} from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import {showMessage, fetch_end, fetch_start} from 'store/actions/fuse';

const styles = () => ({
    root: {
        width: '100%'
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

class RegularLoginTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canSubmit: false,
            expired: false
        };
    }
    
    form = React.createRef();

    disableButton = () => {
        this.setState({canSubmit: false});
    };

    enableButton = () => {
        this.setState({canSubmit: true});
    };

    onChange = (captcha) => {
        if (captcha === null) {
            this.setState({expired: true});
        } else {
            this.checkCaptcha(captcha);
        }  
    }

    onSubmit = (model) => {
        console.log(model);
        this.props.submitLogin(model);
    };

    componentWillMount(){
        localStorage.clear();
    }
    render()
    {
        const {classes, isLoadingRequest} = this.props;
        const {canSubmit} = this.state;

        return (
            <div className={classes.root}>
                <Formsy
                    onValidSubmit={this.onSubmit}
                    onValid={this.enableButton}
                    onInvalid={this.disableButton}
                    ref={(form) => this.form = form}
                    className="flex flex-col justify-center w-full"
                >
                    <TextFieldFormsy
                        className="mb-16"
                        type="text"
                        name="email"
                        label="Email"
                        validations="isEmail"
                        validationErrors={{
                            isEmail: 'Por favor ingresa un correo valido'
                        }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end"><Icon className="text-20" color="action">email</Icon></InputAdornment>
                        }}
                        variant="outlined"
                        required
                    />

                    <TextFieldFormsy
                        className="mb-16"
                        type="password"
                        name="password"
                        label="Contraseña"
                        // validations={{
                        //     minLength: 4
                        // }}
                        // validationErrors={{
                        //     minLength: 'Al menos 4 caracteres'
                        // }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end"><Icon className="text-20" color="action">vpn_key</Icon></InputAdornment>
                        }}
                        variant="outlined"
                        required
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="w-full mx-auto mt-16 normal-case"
                        aria-label="LOG IN"
                        disabled={!canSubmit || isLoadingRequest}
                        value="legacy"
                    >
                    {isLoadingRequest && <CircularProgress size={20} />}
                        Ingresar
                    </Button>
                    

                </Formsy>

            </div>
        );
    }
}


function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        showMessage,
        fetch_start,
        fetch_end,
        submitLogin: Actions.submitLogin
    }, dispatch);
}

function mapStateToProps({auth, fuse})
{
    return {
        login: auth.login,
        isLoadingRequest: fuse.request.loading > 0
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(RegularLoginTab)));
